import { css } from '@emotion/css';

import { colors } from '@editor2/styles/colors';
import { lg, md } from '@editor2/styles/breakpoints';

export const header = css`
	background-color: ${colors.background};
	border-bottom: 1px solid ${colors.border};
	min-height: 50px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 10px 40px;
	font-size: 14px;

	z-index: 100;
	width: 1000px;
	position: sticky;
	top: 0;

	@media (max-width: ${lg}px) {
		width: auto;
	}

	.courseInfo {
		display: flex;
		align-items: center;
		flex: 1 1 80%;

		span {
			color: ${colors.secondaryText};
			font-weight: 600;
		}
	}

	.webtextView {
		margin-right: 10px;
		padding: 0 10px;
		border-right: 1px solid ${colors.border};
		white-space: nowrap;
	}
`;

export const indent = css`
	top: 50px;
`;

export const breadcrumbs = css`
	display: flex;
	flex-wrap: wrap;
`;

export const breadcrumbItem = css`
	padding-right: 5px;
	max-width: 285px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;

	:not(:first-child) {
		::before {
			content: '/';
			padding-right: 5px;
		}

		.navigation {
			display: none;
		}
	}
`;

export const options = css`
	display: flex;
	justify-content: flex-end;
	align-items: center;
	flex: 1 1 25%;
`;

export const navigationBlock = css`
	display: flex;
	justify-content: space-between;
	padding: 10px 40px;
	border-bottom: 1px solid #dee2e6;

	a {
		color: ${colors.mainText};
	}

	.pageType {
		color: ${colors.secondaryText};
	}
`;
